import React, {useState, useContext} from 'react';
import { BrowserRouter as Router, Route, Routes, Link } from "react-router-dom";
import ReactDOM from 'react-dom';
import Modal from 'react-modal';
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import Context from "../../../context/context";
import CalculatorModal from '../statistics/Calculators/Calculatorpopup';
import GrowthChartModal from "../statistics/UFO_Growth_Chart/popup";
import TokenDistributionModal from "../statistics/Token_Distribution/TokenDistributionModal";
import ValueGenerationModal from "../statistics/ValueGenerationModal";

const Sections2 = () => {
  const {account, onConnect, providers, UFOVolume, ptgcPrice, ufoPrice, plsPrice, CID} = useContext(Context);
  const { ref, inView } = useInView({ triggerOnce: true });
  const [growthChartModalStatus, setGrowthChartModalStatus] = useState(false);
  const [tokenDistributionModalStatus, setTokenDistributionModalStatus] = useState(false);
  const [valueGenerationModalStatus, setValueGenerationModalStatus] = useState(false);
  const [calculatorModalStatus, setCalculatorModalOpen] = useState(false);

return (
  <>
  <section className="boXSec boXSecUp padsec pt-0 UFOSEC">
    <div className="container">
      <div className="row">
        <div className="col-lg-4">
          <div className="snX" data-aos="fade-up"  data-aos-delay="300" data-aos-duration="400">
            <h4>IPFS</h4>
            <p>Hash: <br/><b className="wordbreak">{CID}</b> <b>The original code on a decentralized network.</b> Gateways spotted with said hash:</p>
            <div className="posbottombtn">
              <div className="someBtnsmod100 someBtns SRTOP  row ">
                <div className="col-12">
                  <a href={"https://ipfs.goptgc.com/ipfs/"+CID+'/#/'} className="someSnbtn d-flex justify-content-between align-items-center mt-4"><span>ipfs.goptgc.com</span> <img src="./images/circle_arrow.svg" className="img-fluid" /></a>
                </div>
              </div>
            </div>
          </div>
          <div className="snX snX2" data-aos="fade-up"  data-aos-delay="300" data-aos-duration="1400">
            <h4>Token Distribution</h4>
            <p>Fair and distributed token allocation to support sustained project growth. View the current token supply distribution, including supply distribution , holder supply % breakdown, and position dollar value.</p>
            <div className="posbottombtn">
              <div className="someBtnsmod100 someBtns SRTOP  row ">
                <div className="col-12">
                  <button onClick={() => setTokenDistributionModalStatus(true)} className="someSnbtn d-flex justify-content-between align-items-center mt-4"><span>View Now</span> <img src="./images/circle_arrow.svg" className="img-fluid" /></button>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        <TokenDistributionModal modalIsOpen={tokenDistributionModalStatus} closeModal={() => setTokenDistributionModalStatus(false)} ufoPrice={ufoPrice}/>

        <div className="col-lg-4">
          <div className="snX snXBig" data-aos="fade"  data-aos-delay="1000" data-aos-duration="800">
            <h1 className="wordbreak" ref={ref}>{inView && <CountUp end={89432844283155.0} duration={3} separator="," />}</h1>
            <h4 className="mt-2">View<br/>Calculator</h4>
            <p>Easily estimate your earnings or rewards using our built-in calculator.</p>
            <div className="mt-0 pt-2 mySPace"></div>
            <div className="priceBox ">
              <div className="PBox1">
                <div className="PBox2">
                  <img className="" src="./images/ufo.svg" alt="" />
                  <div className="mt-3 d-flex justify-content-between">
                    <p className="mb-1"><span className="dollor">$</span>{ufoPrice}</p>
                    <p className="mb-1">{parseFloat(ufoPrice / plsPrice).toFixed(2)}<span className="bottomCoin">PLS</span></p>
                  </div>
                </div>
              </div>
            </div>
              <div className="someBtnsmod100 someBtns    ">
                <button onClick={() => setCalculatorModalOpen(true)} className="someSnbtn FFFFFF d-flex justify-content-between align-items-center mt-4"><span>View Now</span> <div className="iconiconSR"> <img src="./images/circle_arrow.svg" className="img-fluid" /></div></button>
              </div>
          </div>
        </div>

        <CalculatorModal 
          modalIsOpen={calculatorModalStatus} 
          closeModal={() => setCalculatorModalOpen(false)}  
          volumeDaily={UFOVolume.volumeDaily} 
          volumeWeekly={UFOVolume.volumeWeekly} 
          volumeMonthly={UFOVolume.volumeMonthly} 
          volumeSemiAnnually={UFOVolume.volumeSemiAnnually} 
          volumeAnnually={UFOVolume.volumeAnnually} 
          ptgcPrice={ptgcPrice}
        />

        <div className="col-lg-4">
          <div className="snX snX3" data-aos="fade-up"  data-aos-delay="300" data-aos-duration="1200">
            <h4>Fees<br/>Allocation</h4>
            <p className="mb-0">Value is derived from token volume and transactions, with a 6% fee on all transactions allocated entirely to project growth and sustainability via rewards for holders, liquidity farming, and buy and burn mechanism.</p>
            <div className="posbottombtn">
              <div className="someBtnsmod100 someBtns SRTOP  row ">
                <div className="col-12">
                  <button onClick={() => setValueGenerationModalStatus(true)} className="someSnbtn d-flex justify-content-between align-items-center mt-4"><span>View Now</span> <img src="./images/circle_arrow.svg" className="img-fluid" /></button>
                </div>
              </div>
            </div>
          </div>
          <ValueGenerationModal 
            modalIsOpen={valueGenerationModalStatus} 
            closeModal={() => setValueGenerationModalStatus(false)}
            volumeDaily={UFOVolume.volumeDaily} 
            volumeWeekly={UFOVolume.volumeWeekly} 
            volumeMonthly={UFOVolume.volumeMonthly} 
            volumeQuarterly={UFOVolume.volumeQuarterly}
            volumeSemiAnnually={UFOVolume.volumeSemiAnnually} 
            volumeAnnually={UFOVolume.volumeAnnually} 
          />
          <div className="snX snX4" data-aos="fade-up"  data-aos-delay="300" data-aos-duration="1600">
            <img src="./images/UFOboxchart.svg" className="img-fluid mb-2" />
            <h4 className="mb-0">UFO Growth Chart</h4>
            <div className="posbottombtn">
              <div className="someBtnsmod100 someBtns SRTOP  row ">
                <div className="col-12">
                  <button onClick={() => setGrowthChartModalStatus(true)} className="someSnbtn d-flex justify-content-between align-items-center mt-0">
                    <span>View Now</span> 
                    <img src="./images/circle_arrow.svg" className="img-fluid"/>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <GrowthChartModal modalIsOpen={growthChartModalStatus} closeModal={() => setGrowthChartModalStatus(false)}/>
  </>
  );
};

export default Sections2;